export const LOCAL_STORAGE_KEY = 'first-point';
export const SESSION_STORAGE_KEY = 'session-point';

export const PHONE = '';
export const EMAIL = 'a.fedosov@andersenlab.com';

export const MEETUP_DATE = '2026-05-20';
export const MEETUP_TIME = '13:00';
export const TIME_ZONE = 'CST';
